import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { root } from '../../../../../../../store/constants';
import { IGetState } from '../../../../../../../types/types';

export const onTabActive = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        root.App.router.navigate(root.App.router.getUrl('preview'), { trigger: false });
    };
    return action;
};
